// src/components/Arapaima.jsx
import React, { useRef, useState } from 'react';
import PreySchool from '../../PreySchool.jsx';
import PredatorChase from '../../PredatorChase.jsx';

/**
 * Arapaima + Neon Tetra school bundle with explicit z-index control.
 */
export default function Arapaima({
  // Predator props
  predatorImgSrc = '/images/animals/0_5m/predator/arapaima_head.png',
  predatorWidth = 100,
  predatorSpeed = 2,
  predatorCatchRadius = 20,
  predatorZ = 90,          // on top
  highlight = false,
  theme = 'light',
  onPredatorClick,

  // School props
  schoolImgSrc = '/images/animals/0_5m/prey/neon_tetra_head.png',
  schoolCount = 20,
  schoolDuration = '10s',
  schoolZ = 80,            // below predator

  // Behavior
  startActive = true,      // ⬅️ show predator immediately by default

  // Optional custom catcher
  onCatch,
}) {
  const schoolRef = useRef(null);
  const [chaseOn, setChaseOn] = useState(!!startActive);

  const handleCatchDefault = (fishEl) => {
    fishEl.style.transition = 'opacity .3s';
    fishEl.style.opacity = 0;
    setTimeout(() => {
      fishEl.style.opacity = 1;
      fishEl.style.left = `${Math.random() * 80 + 10}%`;
    }, 500);
  };

  return (
    <div className="relative w-full h-64 overflow-visible">
      {/* Prey School */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: schoolZ,
          pointerEvents: 'auto',
        }}
      >
        <PreySchool
          ref={schoolRef}
          count={schoolCount}
          schoolDuration={schoolDuration}
          imgSrc={schoolImgSrc}
          onFlee={() => setChaseOn(true)}
        />
      </div>

      {/* Predator */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: predatorZ,
          pointerEvents: 'auto',
        }}
      >
        <PredatorChase
          imgSrc={predatorImgSrc}
          width={predatorWidth}
          speed={predatorSpeed}
          active={chaseOn}                      // ⬅️ starts active if requested
          targetRef={schoolRef}
          catchRadius={predatorCatchRadius}
          onCatch={onCatch || handleCatchDefault}
          onClick={onPredatorClick}
          highlight={highlight}
          theme={theme}
        />
      </div>
    </div>
  );
}
